<template>
    <form id="contact-form" name="contact-form">
        <div class="form-group">
            <input v-model="contacto.name" class="form-control" name="name"  type="text" v-bind:placeholder="tr('enter_name')">
        </div>
        <div class="form-group">
            <input v-model="contacto.email" class="form-control" name="email" type="email" v-bind:placeholder="tr('enter_email')" >
        </div>
        <div class="form-group">
            <textarea v-model="contacto.message" class="form-control" name="message" v-bind:placeholder="tr('enter_message')"></textarea>
        </div>
        <vue-recaptcha sitekey="6LcjPS4UAAAAAIXm8SZCShzsHZILirdHdlVQ_VfU" ref="recaptcha" @verify="onVerify">
            <button v-on:click.prevent.stop="send" v-bind:class="{ 'disabled' : !valid }" :disabled="!valid" class="button btn_lg btn_blue btn_full upper" type="submit">
                <i class="fa fa-location-arrow"></i> <span v-lang.send_message></span>
            </button>
        </vue-recaptcha>
    </form>
</template>
<script>
    import options from '../../config/app';
    import Form from './index';
    import VueRecaptcha from 'vue-recaptcha';
    export default {
        props : ['contacto'],
        created : Form.created,
        beforeDestroy : Form.beforeDestroy,
        methods : Object.assign({}, Form.methods, {
          validateCaptcha() {
            this.$refs.recaptcha.execute();
          },
          onVerify(response) {
            console.log(response);
          },
        }),
        computed : Form.computed,
        components : {
            VueRecaptcha
        }
    };
</script>

<style lang="scss">
    button
    {
        &.disabled
        {
             opacity: 0.5 !important;
            cursor: not-allowed;
        }
    }
</style>


// WEBPACK FOOTER //
// Simple.vue?0dec1a50